import React from "react";
import DownloadUserList from "./DownloadUsersList";
import DownloadUserAccForm from "./DownloadUserAccForm";
import { DownloadUserProvider } from "./DownloadUsersContext";
import DownloadUserRoles from "./DownloadUserRoles";

const DownloadUsersPage = () => {
  return (
    <DownloadUserProvider>
      <DownloadUserList />
      <DownloadUserAccForm />
      <DownloadUserRoles />
    </DownloadUserProvider>
  );
};

export default DownloadUsersPage;
